import { useState } from 'react'
import { Copy } from '../../icons/Copy'

export function Clipboard({ text }) {
  const [clicked, setClicked] = useState(false)

  function copyToClipboard() {
    navigator.clipboard.writeText(text)
    setClicked(true)
  }

  return (
    <button
      onClick={() => copyToClipboard()}
      className={`*:text-old-primary ${clicked ? '' : 'hover:scale-105'} transition-all`}
    >
      {clicked ? <p>Kopiert!</p> : <Copy />}
    </button>
  )
}
